module.exports = __webpack_public_path__ + "img/vdara4.9e74d2e2.jpg";